import React, { forwardRef, JSX } from 'react';
import { Button } from '../../Button';
import { Modal } from 'react-bootstrap';
import { ModalHeader } from '../../ModalHeader.js';
import { FAIcon } from '../../fa-icon';
import { i18n } from '../../../i18n/translate';
import { onExecuteKeyDown } from '../../../utils/KeyboardUtil';

interface Props {
  buttonDisabled: boolean;
  confirmSelection: () => void;
  enforceSelection: boolean;
  languages: object;
  onClose: () => void;
  renderedTitle: JSX.Element;
  selected: string;
  setSelected: (selected: string) => void;
  showLanguageModal: boolean;
}

const LanguageModalBody = forwardRef<HTMLInputElement, Props>(
  (
    {
      buttonDisabled,
      confirmSelection,
      enforceSelection,
      languages,
      onClose,
      renderedTitle,
      selected,
      setSelected,
      showLanguageModal,
    },
    ref
  ) => {
    return (
      <Modal
        animation={false}
        /* @ts-ignore */
        container={ref}
        aria-labelledby="language-modal-title"
        className="languages-modal"
        dialogClassName="foundry"
        id="languages-modal"
        show={showLanguageModal}
      >
        {/* Remove when below is TypeScript-ified */
        /* @ts-ignore */}
        <ModalHeader
          canClickOff={!enforceSelection}
          closeButton={true}
          onCancel={onClose}
          title={renderedTitle}
          titleId="language-modal-title"
        />
        <Modal.Body>
          <div className="language-picker-area" role="menu" aria-label={i18n.t('select a language')} tabIndex={0}>
            {Object.entries(languages).map(([code, { native_name }]) => {
              const isSelected = selected === code;
              return (
                <div
                  aria-pressed={isSelected}
                  className={`language-option ${isSelected ? 'is-selected' : ''}`}
                  key={code}
                  lang={code}
                  onClick={() => setSelected(code)}
                  onKeyDown={onExecuteKeyDown(() => setSelected(code))}
                  role="button"
                  tabIndex={-1}
                  data-object-type="languages"
                  data-object-id={code}
                  data-selected={isSelected}
                >
                  {native_name}
                  {/* Remove when below is TypeScript-ified */
                  /* @ts-ignore */}
                  {isSelected && <FAIcon listItem={true} icon="check" color="teal" />}
                </div>
              );
            })}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button renderAsLegacy id="language-modal-cancel-button" onClick={onClose} style="secondary" branded={true}>
            {i18n.t('Cancel')}
          </Button>
          <Button
            renderAsLegacy
            disabled={buttonDisabled}
            id="language-modal-save-button"
            onClick={confirmSelection}
            style="primary"
            branded={true}
          >
            {i18n.t('Save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
);
LanguageModalBody.displayName = 'LanguageModalBody';

export { LanguageModalBody };
